export default __webpack_public_path__ + "static/media/livetv.812a34b0.svg";